var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('div',{staticClass:"mt-4"},_vm._l((_vm.locales),function(ref){
var locale = ref.locale;
return _c('v-btn',{key:locale,attrs:{"icon":""},on:{"click":function($event){return _vm.setLocale(locale)}}},[_vm._v(" "+_vm._s(locale)+" ")])}),1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }